import React, { ReactNode } from "react"
import styled from "styled-components"

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${(p) => p.theme.colors.greyLighter};
  padding: 0 2rem 4rem;
  color: ${(p) => p.theme.colors.black};
  z-index: 10001;
  overflow-y: scroll;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    width: 50%;
    left: auto;
    padding: 0 3rem 4rem;
  }

  hr {
    margin: 2rem 0 3rem;
  }
`

const Blur = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10000;
`

type Props = {
  children?: ReactNode | ReactNode[]
  handleOkClick?: React.MouseEventHandler
  loading?: boolean
  cancelEvent: () => void
}

const EditHalfScreen = ({ children, loading, cancelEvent }: Props) => {
  const closeSideBar = () => {
    cancelEvent()
  }

  return (
    <>
      <Blur onClick={closeSideBar} />
      {loading ? (
        <Container className={"blur"}>{children}</Container>
      ) : (
        <Container>{children}</Container>
      )}
    </>
  )
}

export default EditHalfScreen
